import Popup from 'mapbox-gl-animated-popup';

// For Azure Web PubSub
// import {WebPubSubClient} from '@azure/web-pubsub-client';

// For Momento
import {TopicClient, TopicConfigurations, CredentialProvider} from '@gomomento/sdk-web';

import './popup.css';

import popupSVG from '@fortawesome/fontawesome-free/svgs/solid/comments.svg';

// For Azure Web PubSub
// const PUBSUB_URL = 'wss://minitokyo3d-free.webpubsub.azure.com/client/hubs/Hub';
// const PUBSUB_ACCESS_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3c3M6Ly9taW5pdG9reW8zZC1mcmVlLndlYnB1YnN1Yi5henVyZS5jb20vY2xpZW50L2h1YnMvSHViIiwiaWF0IjoxNjk1NzA5NDMwLCJleHAiOjE2OTU3OTU4MzAsInJvbGUiOlsid2VicHVic3ViLnNlbmRUb0dyb3VwIiwid2VicHVic3ViLmpvaW5MZWF2ZUdyb3VwIl19.opwWlRnQBHAWPIbuhRrdwyCwniOkRJSVwYFUkgTdDVA';
// const PUBSUB_URL = 'wss://minitokyo3d.webpubsub.azure.com/client/hubs/Hub';
// const PUBSUB_ACCESS_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJ3c3M6Ly9taW5pdG9reW8zZC53ZWJwdWJzdWIuYXp1cmUuY29tL2NsaWVudC9odWJzL0h1YiIsImlhdCI6MTY5NDgyNzE5NSwiZXhwIjoxNjk0OTEzNTk1LCJyb2xlIjpbIndlYnB1YnN1Yi5zZW5kVG9Hcm91cCIsIndlYnB1YnN1Yi5qb2luTGVhdmVHcm91cCJdfQ.vnE4nBgJBMKvDjeJKLXF9BVRQEFAmk4NGmoHfn7kYQw';

// For Momento
const MOMENTO_AUTH_TOKEN = 'eyJlbmRwb2ludCI6ImNlbGwtYXAtbm9ydGhlYXN0LTEtMS5wcm9kLmEubW9tZW50b2hxLmNvbSIsImFwaV9rZXkiOiJleUpoYkdjaU9pSklVekkxTmlKOS5leUp6ZFdJaU9pSnVZV2RwUUc1aFoya3RjQzVqYjIwaUxDSjJaWElpT2pFc0luQWlPaUpGYUZsTFJrSkpVME5CUldGRVFXOUxZbGRzZFdGVE1UQmlNblExWW5sSlFTSjkuMmpmekpPREUtZU1ybHk2UVZFRllWTVpJWTMzcm9JaE1Ub01MOVBMcVdNQSJ9';

function addColor(url, color) {
    const encodedColor = color.replace('#', '%23');
    return url.replace('%3e', ` fill=\'${encodedColor}\' stroke=\'${encodedColor}\'%3e`);
}

class PopupPlugin {

    constructor(options) {
        const me = this;

        me.id = 'popup';
        me.name = {
            en: 'Popup',
            ja: 'ポップアップ'
        };
        me.iconStyle = {
            backgroundSize: '32px',
            backgroundImage: `url("${addColor(popupSVG, 'white')}")`
        };
        me.enabled = true;
        me._onMouseDown = me._onMouseDown.bind(me);
        me._onMouseCancel = me._onMouseCancel.bind(me);
    }

    onAdd(map) {
        this.map = map;
    }

    onEnabled() {
        const me = this,
            {map} = me;

        map.on('mousedown', me._onMouseDown);
        map.on('touchstart', me._onMouseDown);
        map.on('mouseup', me._onMouseCancel);
        map.on('touchend', me._onMouseCancel);
        map.on('drag', me._onMouseCancel);
        map.on('rotate', me._onMouseCancel);

        /*
        // For Azure Web PubSub
        me.client = new WebPubSubClient(`${PUBSUB_URL}?access_token=${PUBSUB_ACCESS_TOKEN}`);
        me.client.on('group-message', e => {
            const popup = new Popup({
                className: 'popup-text',
                closeButton: false,
                closeOnClick: false
            })
                .setLngLat(e.message.data.center)
                .setHTML([
                    e.message.data.text
                ].join(''))
                .addTo(map.map);
            me.popups.push(popup);
            setTimeout(() => {
                popup.remove();
            }, 300000)
        });
        me.client.start();
        me.client.joinGroup('group1');
        */

        // For Momento
        me.client = new TopicClient({
            configuration: TopicConfigurations.Default.latest(),
            credentialProvider: CredentialProvider.fromString({apiKey: MOMENTO_AUTH_TOKEN})
        });
        me.client.subscribe('mini-tokyo', 'chat', {
            onError: () => {
            },
            onItem: item => {
                const data = JSON.parse(item.valueString());
                const popup = new Popup({
                    className: 'popup-text',
                    closeButton: false,
                    closeOnClick: false
                })
                    .setLngLat(data.center)
                    .setHTML([
                        data.text
                    ].join(''))
                    .addTo(map.map);
                me.popups.push(popup);
                setTimeout(() => {
                    popup.remove();
                }, 300000)
            }
        }).then(topic => {
            me.topic = topic;
        });

        me.popups = [];
    }

    onDisabled() {
        const me = this,
            {map} = me;

        map.off('mousedown', me._onMouseDown);
        map.off('touchstart', me._onMouseDown);
        map.off('mouseup', me._onMouseCancel);
        map.off('touchend', me._onMouseCancel);
        map.off('drag', me._onMouseCancel);
        map.off('rotate', me._onMouseCancel);

        // For Azure Web PubSub
        // me.client.stop();

        // For Momento
        me.topic.unsubscribe();

        me.popups.forEach(popup => {
            popup.remove();
        });
    }

    _onMouseDown(e) {
        const me = this,
            {map} = me;

        me.timeout = setTimeout(() => {
            const popup = new Popup({
                    className: 'popup-input',
                    closeOnClick: false
                })
                    .setLngLat(e.lngLat)
                    .setHTML([
                        '<input id="text-input" class="text-input" type="text" placeholder="コメントを入力">',
                        '<br>',
                        '<button id="send-button" class="send-button" disabled>送信</button>'
                    ].join(''))
                    .addTo(map.map),
                inputElement = map.container.querySelector('#text-input'),
                buttonElement = map.container.querySelector('#send-button');

            inputElement.addEventListener('input', () => {
                buttonElement.disabled = !inputElement.value.match(/\S/);
            });
            buttonElement.addEventListener('click', () => {
                console.log({
                    text: inputElement.value,
                    center: e.lngLat
                });

                // For Azure Web PubSub
                // me.client.sendToGroup('group1', {
                //     text: inputElement.value,
                //     center: e.lngLat
                // }, 'json');

                // For Momento
                me.client.publish('mini-tokyo', 'chat', JSON.stringify({
                    text: inputElement.value,
                    center: e.lngLat
                }));

                popup.remove();
            });
            if (me.inputPopup) {
                me.inputPopup.remove();
            }
            me.inputPopup = popup;
        }, 1000);
    }

    _onMouseCancel() {
        const me = this;

        if (me.timeout) {
            clearTimeout(me.timeout);
        }
    }

}

export default function() {
    return new PopupPlugin();
}
